import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSseSubscribe, sseDesignsThumbnailsOptions } from 'packages/sse';
import type { DesignThumbnailItem } from 'packages/services/designsService';
import { updateThumbnails } from 'packages/store/creatives/creatives.actions';
import { updateCollectionsThumbnails } from 'packages/store/collections/collections.actions';
import { updateTemplateThumbnails } from 'packages/store/templates/templates.actions';
import { updateCategoryThumbnails } from 'packages/store/categories/categories.actions';
import useSuperSet from './useSuperSet';

const emptyCreativeIds: number[] = [];

export default function useCreativeThumbnailsUpdates(pendingIds: number[]) {
    const dispatch = useDispatch();

    // prevents unnecessary re-subscriptions when pendingIds change
    // the array stays the same until there is no new items in pendingIds
    const memoizedPendingIds = useSuperSet(pendingIds);
    const creativeIds = pendingIds.length ? memoizedPendingIds : emptyCreativeIds;

    const onMessage = (items: DesignThumbnailItem[]) => {
        dispatch(updateThumbnails(items));
        dispatch(updateTemplateThumbnails(items));
        dispatch(updateCollectionsThumbnails(items));
        dispatch(updateCategoryThumbnails(items));
    };

    const subscribeDesignThumbnails = useSseSubscribe(sseDesignsThumbnailsOptions({ creativeIds, onMessage }));

    useEffect(() => {
        if (!creativeIds.length) {
            return;
        }

        return subscribeDesignThumbnails();
    }, [creativeIds, subscribeDesignThumbnails]);
}
